


























import mixins from 'vue-typed-mixins';
import { DataTableHeader, DataTableCompareFunction } from 'vuetify';
import SurveyUtils, {
  SurveyGroup,
  Survey,
  SurveyParticipation,
} from '@/utils/SurveyUtils';
export default mixins().extend({
  computed: {
    headers(): DataTableHeader<SurveyGroup>[] {
      return [
        { text: this.$i18n.tc('model.common.name'), value: 'name.admin' },
        { text: this.$i18n.tc('model.common.state'), value: 'state' },
      ];
    },
  },
  data(): {
    surveys?: Survey[];
    surveyGroup?: Partial<SurveyGroup>;
    participants?: SurveyParticipation[];
    paricipantCount?: number;
  } {
    return {
      surveys: undefined,
      surveyGroup: undefined,
      participants: undefined,
      paricipantCount: 0,
    };
  },
  async mounted() {},
  methods: {
    async open(surveyGroup: SurveyGroup) {
      try {
        this.surveys = await SurveyUtils.api.survey.list({
          surveygroupid: surveyGroup?.id as number,
        });
        this.participants = await SurveyUtils.api.surveyParticipation.list({
          surveygroupid: surveyGroup?.id as number,
          submissionstate: 'NOT SUBMITTED',
        });
        if (this.participants) {
          this.paricipantCount = Object.keys(this.participants).length;
        }
      } catch (error) {
        this.$alert.show('mount', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
      this.surveyGroup = surveyGroup;
      (this.$refs.modal as any).open();
    },
    async submit() {
      try {
        if (this.surveyGroup) {
          (this.$refs.alert as any)?.hide('submit');
          await SurveyUtils.api.surveyGroup.update(this.surveyGroup);
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.default', {
              values: [this.$languageobj('model.surveyGroup.label')],
            }),
          });
        }
        this.surveys = undefined;
        (this.$refs.modal as any).resolve();
      } catch (error) {
        (this.$refs.alert as any)?.show('submit', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
    cancel() {
      this.surveys = undefined;
      this.surveyGroup = undefined;
      (this.$refs.modal as any).resolve();
    },
  },
});
